var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIllustration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 132,
    viewBox: "0 0 230 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H222C226.418 0 230 3.58172 230 8V132H0V8Z",
    fill: "#ECE7FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32.5H153C157.142 32.5 160.5 35.8579 160.5 40V92C160.5 96.1421 157.142 99.5 153 99.5H77C72.8579 99.5 69.5 96.1421 69.5 92V40C69.5 35.8579 72.8579 32.5 77 32.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32.5H153C157.142 32.5 160.5 35.8579 160.5 40V92C160.5 96.1421 157.142 99.5 153 99.5H77C72.8579 99.5 69.5 96.1421 69.5 92V40C69.5 35.8579 72.8579 32.5 77 32.5Z",
    stroke: "#B19DFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 81 49)",
    fill: "#ECE7FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 81 62)",
    fill: "#ECE7FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 81 75)",
    fill: "#ECE7FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 81 88)",
    fill: "#ECE7FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 70.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8B6CF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.333 85.7776C159.333 82.9855 157.069 80.722 154.277 80.722C151.485 80.722 149.222 82.9855 149.222 85.7776C149.222 88.5697 151.485 90.8331 154.277 90.8331C157.069 90.8331 159.333 88.5697 159.333 85.7776ZM160.777 85.7776C160.777 87.3123 160.244 88.7218 159.355 89.8337L162.01 92.4892C162.292 92.7712 162.292 93.2284 162.01 93.5104C161.728 93.7925 161.271 93.7925 160.989 93.5104L158.333 90.855C157.222 91.7445 155.812 92.2776 154.277 92.2776C150.687 92.2776 147.777 89.3674 147.777 85.7776C147.777 82.1877 150.687 79.2776 154.277 79.2776C157.867 79.2776 160.777 82.1877 160.777 85.7776Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchIllustration.36b697cc7246ad4e049bad611750b006.svg";